import { findValidFieldId } from "./findValidFieldId";

const key = "add-invalid-children";

const applicable = (resp) => {
	return resp.config.url.match(/api\/forms\/[0-9]*$/);
};

const ruleJson = (validFieldId) => ({
	"Id": 4,
	"Title": "Invalid children",
	"Operator":
	{
		"Id": 2,
		"Code": "OR",
		"Name": "Or"
	},
	"Children":
	[
		{
			"Id": 4,
			"Title": "Unknown Engine",
			"Operator":
			{
				"Id": 2,
				"Code": "OR",
				"Name": "Or"
			},
			"Engine":
			{
				"Id": 1,
				"Code": "RANDOM-UNKNOWN",
				"Name": "NotKnown"
			},
			"Conditions":
			[
				{
					"Id": 1,
					"Field":
					{
						"Id": validFieldId
					}
				}
			]
		}
	],
	"Triggers":
	[
		{
			"Operator":
			{
				"Id": 1,
				"Code": "BLOCKSAVE",
				"Name": "Block Saving"
			},
			"Type":
			{
				"Id": 1,
				"Code": "VALIDATION",
				"Name": "Validation"
			}
		}
	]
});

const modify = (resp) => {
	if(!resp.data.Data?.Rules) {
		return;
	}

	const ruleWithUnknownTrigger = ruleJson(findValidFieldId(resp.data.Data));
	resp.data.Data.Rules.push(ruleWithUnknownTrigger);
};

export const addInvalidChildren = [key, applicable, modify];